import CalendarHeatMap from './CalendarHeatMap'

export default CalendarHeatMap
